/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import Tablecomponent from "../DeliveryTracking/table/TableComp";
import Card from "@material-ui/core/Card";
import { NavLink } from "react-router-dom";
import "./DashboardTable.css";
import dateFormat from "dateformat";
import AddIcon from "@material-ui/icons/Add";
import axiosInstance from "../../api/axiosInstance";
import { apiurl, formatMoney } from "../../App";
import dateformat from "dateformat";
import more from "../../Images/more.svg";
import DashImg from "../../assets/images/pharm_dashboard.svg";
// import DocImg from "../../assets/images/file.png";
import calendericon from "../../assets/images/calendar.png";
import revenuicon from "../../assets/images/Layer_2.png";
import totalmedicineicon from "../../assets/images/TotalmedicineyellowBG.svg";
import plusicon from "../../assets/images/add_plus.png";
import burgermenu from "../../assets/images/Burgermenu.svg";
import tickblackicon from "../../assets/images/tickblack.svg";
import tickfillicon from "../../assets/images/tickfill.svg";
import MedicineModal from "../PrescriptionEntry/MedicineModal.jsx";
import cancel from "../../Images/cancel.svg";
import Select from "react-select";
import ShowNotification from "../ShowNotification/ShowNotification";


import Cookies from "js-cookie";
import {
  HiOutlineUser,
  HiOutlineCalendar,
  HiOutlinePhone,
  HiOutlineUserGroup,
  HiOutlinePlus,
  HiOutlineX,
  HiOutlineCollection,
  HiOutlineCash,
  HiOutlineDocumentText,
  HiOutlineClipboardList,
  HiOutlineCube,
  HiOutlineTrendingUp,
  HiOutlineChevronRight,
  HiOutlineEye,
  HiOutlinePrinter,
  HiOutlinePlusCircle,
  HiOutlineRefresh,
  HiOutlineCheckCircle,
  HiOutlineClock,
  HiOutlineArchive,
  HiOutlineXCircle,
  HiOutlineShoppingCart,
} from "react-icons/hi";
import moment from "moment";

import { decryptAESKey, setupKeys, encryptData, decryptData } from '../Crypto_Helpers/cryptoHelper';
import { initEncryptionSession } from '../../encryptionSession';

const current_date = dateFormat(new Date(), "dd-mmm-yy");

class DashboardTable extends React.Component {
  state = {
    addopen: false,
    props_loading: true,
    tabledatavalue: [],
    prescriptionEntryData: null,
    ViewData: "",
    totalValue: "",
    prescription: "",
    quotes_pending: "",
    pending_approval: 0,
    pending_order: 0,
    deliverd: 0,
    cancel_count: "",
    total_revenue: "",
    visible: false,
    successmsg: "",
    issuccess: false,
    startDate: dateformat(new Date(), "yyyy-mm-dd"),
    endDate: dateformat(new Date(), "yyyy-mm-dd"),
    prescriptionopenview: false,
    isNewModal: false,
    userName: Cookies.get("User_name") || localStorage.getItem("User_name") || "",
    medicineList: null,
    pdfData: null,
    getTotalRevenue: 0,
    isModalOpen: false,
    searchmedicinedata: [],
    duplicatesearchmedicinedata: [],
    patientPricriptionName: "",
    patientPricriptionGender: "",
    patientPricriptionAge: "",
    patientPricriptionPhoneNumber: "",
    phoneSearchResults: [],
    showPhoneDropdown: false,
    searchingPhone: false,
    errors: {
      patientPricriptionName: "",
      patientPricriptionGender: "",
      patientPricriptionAge: "",
      patientPricriptionPhoneNumber: "",
    },
  };
  toggleNewModal = () => {
    this.setState((prevState) => ({
      isNewModal: !prevState.isNewModal,
      errors: {},
    }), () => {
      if (this.state.isNewModal) {
        this.getMedicineList();
      }
    });
  };
  handleTickClick = (index, value) => {
    const updatedData = [...this.state.duplicatesearchmedicinedata];
    if (updatedData[index]) {
      updatedData[index].foodtype = Number(value);
      this.setState({ duplicatesearchmedicinedata: updatedData });
    }
  };
  isNewModal = () => {
    this.setState({
      isNewModal: false,
      duplicatesearchmedicinedata: [],
      patientPricriptionName: "",
      patientPricriptionGender: "",
      patientPricriptionAge: "",
      patientPricriptionPhoneNumber: "",
      errors: {},
    });
  };
  modelopen = (data, id) => {
    if (data === "view") {
      let prescriptionEntryData = this.state.totalValue.filter(
        (val) => val.prescription_id === id
      );

      if (
        prescriptionEntryData.length > 0 &&
        !prescriptionEntryData.medicines
      ) {
        prescriptionEntryData[0].medicines = [];
      }

      this.setState(
        {
          prescriptionEntryData,
          prescriptionopenview: true,
        },
        () => { }
      );
    } else if (data === "add") {
      let prescriptionEntryData = this.state.totalValue.filter(
        (val) => val.prescription_id === id
      );

      if (
        prescriptionEntryData.length > 0 &&
        !prescriptionEntryData.medicines
      ) {
        prescriptionEntryData[0].medicines = [];
      }

      this.setState({ addopen: true, prescriptionEntryData });
    }
  };
  getBack = () => {
    this.setState({
      addopen: !this.state.addopen,
    });
  };
  handleClose = () => {
    this.setState({ prescriptionopenview: false });
  };
  closemodal = () => {
    this.setState(
      {
        addopen: false,
        prescriptionopenview: false,
        props_loading: true,
        tabledatavalue: [],
        totalValue: "",
        prescription: "",
        quotes_pending: "",
        cancel_count: "",
        total_revenue: "",
        pending_approval: 0,
        pending_order: 0,
        deliverd: 0,
      },
      () => {
        this.GetDashboardFunction();
      }
    );
  };
  ProfileView = (id) => {
    this.setState({ open: true });
  };
  componentDidMount() {
    const cachedName = Cookies.get("User_name") || localStorage.getItem("User_name") || "";
    if (cachedName) {
      this.setState({ userName: cachedName });
    }
    this.fetchUserProfile();
    this.getMedicineList();
    this.getRevenueIncome();
    this.GetDashboardFunction();
    this.intervalId = setInterval(() => {
      this.GetDashboardFunction();
    }, 120000);
  }

  fetchUserProfile = async () => {
    try {
      const pharmId =
        Cookies.get("pharmacy_id") ||
        Cookies.get("vendorId") ||
        localStorage.getItem("pharmacy_id") ||
        localStorage.getItem("vendorId") ||
        "0";

      const aesKey = await initEncryptionSession();
      const payload = { pharm_id: pharmId };
      let requestData = payload;
      if (aesKey) {
        try {
          const encrypted = await encryptData(payload, aesKey);
          requestData = { objects: encrypted };
        } catch (e) {
          requestData = payload;
        }
      }

      const response = await axiosInstance.post(apiurl + "pharmacy/getPharmProfile", requestData);
      let dataList = [];
      if (response && response.data) {
        if (Array.isArray(response.data.data)) {
          dataList = response.data.data;
        } else if (typeof response.data.data === "string" && aesKey) {
          try {
            dataList = await decryptData(response.data.data, aesKey);
          } catch (e) {
            dataList = [];
          }
        }
      }

      if (Array.isArray(dataList) && dataList.length > 0) {
        const item = dataList[0];
        const pName = item.vendor_name || item.contact_person || Cookies.get("User_name") || "";
        const logoUrl = item.vendor_filename || item.vendor_profile_path || "";
        if (pName) {
          Cookies.set("User_name", pName);
          localStorage.setItem("User_name", pName);
          this.setState({ userName: pName });
        }
        if (logoUrl) {
          Cookies.set("profilePath", logoUrl);
          localStorage.setItem("profilePath", logoUrl);
        }
      }
    } catch (e) {
      console.error("Dashboard fetchUserProfile error:", e);
    }
  };

  componentWillUnmount() {
    // Clear the interval when the component is unmounted to avoid memory leaks
    clearInterval(this.intervalId);
  }
  viewmedicineList = (data) => {
    this.setState({
      pdfData: data,
      medicineList: data.p_medicinedetails, // Update the medicine list from `data`
      isModalOpen: true, // Open the modal
    });
  };
  handleCloseModal = () => {
    this.setState({ isModalOpen: false });
  };
  getMedicineList = async () => {
    try {
      const pharmId =
        Cookies.get("pharmacy_id") ||
        Cookies.get("vendorId") ||
        localStorage.getItem("pharmacy_id") ||
        localStorage.getItem("vendorId") ||
        0;

      const aesKey = await initEncryptionSession();
      const payload = {
        pharmacy_id: pharmId,
        pageNumber: 0,
        pageSize: 0,
      };

      let requestData = payload;
      if (aesKey) {
        try {
          const encrypted = await encryptData(payload, aesKey);
          requestData = { objects: encrypted };
        } catch (e) {
          requestData = payload;
        }
      }

      const response = await axiosInstance.post("pharmacy/get_mas_pharm_medicine_rate", requestData);
      let list = [];
      if (response && response.data) {
        if (Array.isArray(response.data.data)) {
          list = response.data.data;
        } else if (typeof response.data.data === "string" && aesKey) {
          try {
            list = await decryptData(response.data.data, aesKey);
          } catch (e) {
            list = [];
          }
        }
      }

      const tabledatavalue = [];
      if (Array.isArray(list)) {
        list.forEach((val) => {
          const tabletPrice = parseFloat(val.per_tablet_price) || 0;
          tabledatavalue.push({
            value: val.id,
            label: `${val.medicine_name}${val.dosage ? ` (${val.dosage})` : ""}`,
            medicine_name: val.medicine_name,
            dosage: val.dosage,
            price: 0,
            counts: [0, 0, 0, 0],
            days: 1,
            originalPrice: tabletPrice,
            totalmedicine: 0,
            foodtype: 0, // 0 = Before Food, 1 = After Food
            totalAmount: 0,
          });
        });
      }

      this.setState({ searchmedicinedata: tabledatavalue });
    } catch (err) {
      console.error("getMedicineList error in DashboardTable:", err);
    }
  };
  // GET API FUNCTION
  GetDashboardFunction = async () => {
    const aesKey = await initEncryptionSession();
    var data = {
      pharmacy_id: Cookies.get("pharmacy_id") ? Cookies.get("pharmacy_id") : 0,
      from_date: this.state.startDate,
      to_date: this.state.endDate,
    }
    const encrypted = await encryptData(data, aesKey);
    axiosInstance({
      method: "post",
      url: apiurl + "pharmacy/getPharmDashboard",
      data: {
        objects: encrypted,
      },
    })
      .then(async (response) => {
        if (!response.data.data || !response.data.data.length) return;
        const rawTransaction = response.data.data[0].today_transaction;
        const rawCount = response.data.data[0].dashboard_count;

        // Decrypt both encrypted payloads
        const transactions = rawTransaction && typeof rawTransaction === "string"
          ? await decryptData(rawTransaction, aesKey)
          : (Array.isArray(rawTransaction) ? rawTransaction : []);

        const CardData = rawCount && typeof rawCount === "string"
          ? await decryptData(rawCount, aesKey)
          : (rawCount || {});

        const sortedTransactions = [...transactions].sort((a, b) => Number(b.prescription_id || 0) - Number(a.prescription_id || 0));
        var tabledatavalue = [];
        sortedTransactions.map((val, index) => {
          tabledatavalue.push({
            orderId: val.custom_order_id,
            customer: val.customer,
            gender: val.gender,
            customer_phno: val.phone_no,
            doctorName: val.doctor_name,
            status: val.status,
            id: val.prescription_id,
            rawItem: val,
          });
        });
        this.setState({
          tabledatavalue: tabledatavalue,
          totalValue: transactions,
          prescription: CardData.total_prescription,
          quotes_pending: CardData.quotes_pending,
          pending_approval: CardData.pending_approval || 0,
          pending_order: CardData.pending_orders || 0,
          deliverd: CardData.delivered_orders || 0,
          cancel_count: CardData.cancelled_orders,
          //total_revenue: formatMoney(CardData.total_revenue),
          props_loading: false,
        });
      })
      .catch((error) => {
        console.error("GetDashboardFunction error:", error);
      });
  };
  handleSelectDate = (item) => {
    if (item && item[0]) {
      var fromDate = dateFormat(item[0].startDate, "yyyy-mm-dd");
      var toDate = dateFormat(item[0].endDate, "yyyy-mm-dd");
      this.setState(
        {
          startDate: fromDate,
          endDate: toDate,
        },
        () => this.GetDashboardFunction()
      );
    }
  };
  // handleopenSuccess = (successmsg, issuccess) => {
  //   this.setState({ visible: true, successmsg, issuccess });
  // };
  // handleCloseSuccess = () => {
  //   this.setState({ visible: false });
  // };
  handleNameChange = (value) => {
    // Allow only letters and spaces
    const regex = /^[a-zA-Z\s]*$/;
    if (regex.test(value)) {
      this.setState({
        patientPricriptionName: value,
        errors: { ...this.state.errors, patientPricriptionName: "" }  // Clear the error
      });
    }
  };

  handleAgeChange = (value) => {
    // Allow only numbers
    const regex = /^[0-9]*$/;
    if (regex.test(value)) {
      this.setState({
        patientPricriptionAge: value,
        errors: { ...this.state.errors, patientPricriptionAge: "" }  // Clear the error
      });
    }
  };

  handleGenderChange = (value) => {
    this.setState({
      patientPricriptionGender: value,
      errors: { ...this.state.errors, patientPricriptionGender: "" }  // Clear the error
    });
  }

  handlePhoneSearch = async (value) => {
    if (!value || value.length < 3) {
      this.setState({ phoneSearchResults: [], showPhoneDropdown: false });
      return;
    }

    this.setState({ searchingPhone: true, showPhoneDropdown: true });
    try {
      const pharmId =
        Cookies.get("pharmacy_id") ||
        Cookies.get("vendorId") ||
        localStorage.getItem("pharmacy_id") ||
        0;
      const aesKey = await initEncryptionSession();
      const payload = {
        pharmacy_id: pharmId,
        phone: value.trim(),
      };

      let requestPayload = payload;
      if (aesKey) {
        try {
          const enc = await encryptData(payload, aesKey);
          requestPayload = { objects: enc };
        } catch {}
      }

      const resp = await axiosInstance.post(
        apiurl + "pharmacy/searchPatientByPhone",
        requestPayload
      );

      let list = [];
      if (resp?.data) {
        if (Array.isArray(resp.data.rawList)) {
          list = resp.data.rawList;
        } else if (Array.isArray(resp.data.data)) {
          list = resp.data.data;
        } else if (typeof resp.data.data === "string" && aesKey) {
          try {
            list = await decryptData(resp.data.data, aesKey);
          } catch (e) {
            list = [];
          }
        }
      }

      this.setState({
        phoneSearchResults: Array.isArray(list) ? list : [],
        searchingPhone: false,
      });
    } catch (err) {
      console.error("handlePhoneSearch error:", err);
      this.setState({ searchingPhone: false });
    }
  };

  selectPatientFromPhoneSearch = (patient) => {
    let genderVal = "";
    const g = (patient.gender || "").toLowerCase();
    if (g.includes("m") || g.includes("male")) genderVal = "M";
    else if (g.includes("f") || g.includes("female")) genderVal = "F";
    else if (g) genderVal = "other";

    this.setState({
      patientPricriptionName: patient.name || "",
      patientPricriptionAge: patient.age ? String(patient.age) : "",
      patientPricriptionGender: genderVal,
      patientPricriptionPhoneNumber: patient.phonenumber || "",
      patientLookupId: patient.patient_id || null,
      showPhoneDropdown: false,
      phoneSearchResults: [],
      errors: {
        ...this.state.errors,
        patientPricriptionName: "",
        patientPricriptionAge: "",
        patientPricriptionGender: "",
        patientPricriptionPhoneNumber: "",
      },
    });
  };

  handlePhoneNumberChange = (value) => {
    if (/^\d*$/.test(value) && value.length <= 10) {
      this.setState({
        patientPricriptionPhoneNumber: value,
        errors: { ...this.state.errors, patientPricriptionPhoneNumber: "" },
      });
      this.handlePhoneSearch(value);
    }
  };

  selectMedicine = (data) => {
    if (!data) {
      this.setState({ duplicatesearchmedicinedata: [] });
      return;
    }

    const currentData = [...this.state.duplicatesearchmedicinedata];
    const currentValues = currentData.map(item => item.value);

    // 1. Handle items added
    const addedItems = data.filter(item => !currentValues.includes(item.value));
    addedItems.forEach(item => {
      const newItem = {
        ...item,
        counts: [0, 0, 0, 0],
        days: 1,
        totalmedicine: 0,
        price: 0,
        originalPrice: item.originalPrice || 10,
        foodtype: 0
      };
      currentData.push(newItem);
    });

    // 2. Handle items removed (if any were removed from the select dropdown)
    const selectedValues = data.map(item => item.value);
    const finalData = currentData.filter(item => selectedValues.includes(item.value));

    this.setState({ duplicatesearchmedicinedata: finalData });
  };
  medicinedecrenet = (index, tabletindex) => {
    const updatedData = [...this.state.duplicatesearchmedicinedata];
    if (!updatedData[index].counts[tabletindex]) {
      updatedData[index].counts[tabletindex] = 0; // Ensure counts[tabletindex] is initialized
    }
    if (updatedData[index].counts[tabletindex] > 0) {
      updatedData[index].counts[tabletindex] -= 1;
      updatedData[index].totalmedicine =
        updatedData[index].counts.reduce((acc, curr) => acc + curr, 0) *
        updatedData[index].days;
      updatedData[index].price =
        updatedData[index].originalPrice * updatedData[index].totalmedicine;
      // TOTAL AMOUNT CALCULATION DON'T DELETE THIS BELOW LINE
      updatedData[0].totalAmount = updatedData.reduce(
        (sum, item) => sum + item.price,
        0
      );
      this.setState({ duplicatesearchmedicinedata: updatedData });
    }
  };
  medicineincrement = (index, tabletindex) => {
    const updatedData = [...this.state.duplicatesearchmedicinedata];
    if (!updatedData[index].counts[tabletindex]) {
      updatedData[index].counts[tabletindex] = 0; // Ensure counts[tabletindex] is initialized
    }
    updatedData[index].counts[tabletindex] += 1;
    updatedData[index].totalmedicine =
      updatedData[index].counts.reduce((acc, curr) => acc + curr, 0) *
      updatedData[index].days;
    updatedData[index].price =
      updatedData[index].originalPrice * updatedData[index].totalmedicine;
    // TOTAL AMOUNT CALCULATION DON'T DELETE THIS BELOW LINE
    updatedData[0].totalAmount = updatedData.reduce(
      (sum, item) => sum + item.price,
      0
    );
    this.setState({ duplicatesearchmedicinedata: updatedData });
  };
  decrementdays = (index) => {
    const updatedData = [...this.state.duplicatesearchmedicinedata];
    if (updatedData[index].days != 1) {
      updatedData[index].days -= 1;
      updatedData[index].totalmedicine =
        updatedData[index].days *
        updatedData[index].counts.reduce((acc, curr) => acc + curr, 0);
      updatedData[index].price =
        updatedData[index].totalmedicine * updatedData[index].originalPrice;
      //TOTAL AMOUNT CALCULATION DON'T DELETE THIS BELOW LINE
      updatedData[0].totalAmount = updatedData.reduce(
        (sum, item) => sum + item.price,
        0
      );
      this.setState({ duplicatesearchmedicinedata: updatedData });
    }
  };
  incrementdays = (index) => {
    const updatedData = [...this.state.duplicatesearchmedicinedata];
    updatedData[index].days += 1;
    updatedData[index].totalmedicine =
      updatedData[index].days *
      updatedData[index].counts.reduce((acc, curr) => acc + curr, 0);
    updatedData[index].price =
      updatedData[index].totalmedicine * updatedData[index].originalPrice;
    //TOTAL AMOUNT CALCULATION DON'T DELETE THIS BELOW LINE
    updatedData[0].totalAmount = updatedData.reduce(
      (sum, item) => sum + item.price,
      0
    );
    this.setState({ duplicatesearchmedicinedata: updatedData });
  };
  deleteTabletFromArray = (index) => {
    const updatedData = [...this.state.duplicatesearchmedicinedata];
    updatedData.splice(index, 1); // Remove the selected item

    // Recalculate total amount
    const totalAmount = updatedData.reduce((sum, item) => sum + item.price, 0);
    if (updatedData.length > 0) {
      updatedData[0].totalAmount = totalAmount;
    }

    this.setState({ duplicatesearchmedicinedata: updatedData });
  };

  getPrescripnerPhoneNumber = (value) => {
    this.setState({ patientPricriptionPhoneNumber: value });
  };
  getPrescripnerGender = (value) => {
    this.setState({ patientPricriptionGender: value });
  };
  getPrescripnerAge = (value) => {
    this.setState({ patientPricriptionAge: value });
  };
  getPrescripnerName = (value) => {
    this.setState({ patientPricriptionName: value });
  };

  addPresscription = async () => {
    const errors = {};

    // Validation Logic
    if (!this.state.patientPricriptionName) {
      errors.patientPricriptionName = "Name is required";
    }

    if (!this.state.patientPricriptionAge) {
      errors.patientPricriptionAge = "Age is required";
    }

    if (!this.state.patientPricriptionGender) {
      errors.patientPricriptionGender = "Gender is required";
    }

    if (!this.state.patientPricriptionPhoneNumber) {
      errors.patientPricriptionPhoneNumber = "Phone number is required";
    }

    // If there are errors, update state and return
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    // Clear errors if validation passes
    this.setState({ errors: {} });

    this.setState((prevState) => ({
      isNewModal: false, // Explicitly set to false to close the modal
    }));

    // const formData = new FormData();
    // formData.append("patient_id", 0);
    // formData.append("doctor_id", 0);
    // formData.append("is_send_to_pharam", 1);
    // formData.append("pharm_id",localStorage.pharmacy_id ? localStorage.pharmacy_id : 0);
    // formData.append("booking_id", 0);
    // formData.append("file_name", "");
    // formData.append("file_path", "");
    // formData.append("is_walkin", "0");
    // formData.append("medicinedetails",JSON.stringify(this.state.duplicatesearchmedicinedata));
    // formData.append("appointmentDate", dateFormat(new Date(), "yyyy-mm-dd"));
    // formData.append("Name", this.state.patientPricriptionName);
    // formData.append("age", this.state.patientPricriptionAge);
    // formData.append("gender", this.state.patientPricriptionGender);
    // formData.append("phonenumber", this.state.patientPricriptionPhoneNumber);
    const aesKey = await initEncryptionSession();
    const payload = {
      patient_id: 0,
      doctor_id: 0,
      is_send_to_pharam: 1,
      pharm_id: Cookies.get("pharmacy_id") ? Cookies.get("pharmacy_id") : 0,
      booking_id: 0,
      file_name: "",
      file_path: "",
      is_walkin: "0",
      medicinedetails: this.state.duplicatesearchmedicinedata, // no stringify
      appointmentDate: dateFormat(new Date(), "yyyy-mm-dd"),
      Name: this.state.patientPricriptionName,
      age: this.state.patientPricriptionAge,
      gender: this.state.patientPricriptionGender,
      phonenumber: this.state.patientPricriptionPhoneNumber
    };
    const encrypted = await encryptData(payload, aesKey);

    axiosInstance({
      method: "post",
      url: apiurl + "pharmacy/insertPrescriptionManual",
      data: {
        objects: encrypted
      },
    })
      .then((response) => {
        const profile_updated = "Prescription added Successfully.";
        this.handleopenSuccess(profile_updated, true);
        this.clearAppointmentValues();
        this.GetDashboardFunction();
      })
      .catch((error) => {
        console.error("addPresscription error:", error);
      });
  };

  clearAppointmentValues = () => {
    this.setState({
      duplicatesearchmedicinedata: [],
      patientPricriptionName: "",
      patientPricriptionAge: "",
      patientPricriptionGender: "",
      patientPricriptionPhoneNumber: "",
    });
  }
  handleopenSuccess = (successmsg, issuccess) => {
    this.setState({ visible: true, successmsg, issuccess });

    if (this.closeNotificationTimeout) {
      clearTimeout(this.closeNotificationTimeout);
    }
    this.closeNotificationTimeout = setTimeout(() => {
      this.handleCloseSuccess();
    }, 3000);
  };

  getRevenueIncome = async () => {
    const aesKey = await initEncryptionSession();
    var data = {
      pharmacyId: Cookies.get("pharmacy_id"),
      year: new Date().getFullYear()
    };
    const encrypted = await encryptData(data, aesKey);
    axiosInstance({
      method: "post",
      url: apiurl + "pharmacy/getRevenueForPhamracyDashboard",
      data: {
        objects: encrypted
      },
    })
      .then(async (response) => {
        // axiosInstance interceptor may have already decrypted response.data.data
        let dataList = response.data?.data;
        if (!Array.isArray(dataList) && typeof dataList === "string" && aesKey) {
          try {
            dataList = await decryptData(dataList, aesKey);
          } catch (e) {
            dataList = [];
          }
        }
        const total_price = Array.isArray(dataList)
          ? dataList.reduce((sum, item) => sum + parseFloat(item?.total_price || 0), 0)
          : 0;
        this.setState({ getTotalRevenue: formatMoney(total_price) });
      })
      .catch((error) => {
        console.log(error);
      });

  }

  handleCloseSuccess = () => {
    this.setState({ visible: false });
    if (this.closeNotificationTimeout) {
      clearTimeout(this.closeNotificationTimeout);
      this.closeNotificationTimeout = null;
    }
  };
  render() {
    // const { onClose } = this.props;
    const { t } = this.props;
    const heading = [
      { id: "sno", label: "S.No" },
      { id: "orderId", label: "Prescription ID" },
      { id: "customer", label: "Name" },
      { id: "gender", label: "Gender" },
      { id: "customer_phno", label: "Phone No" },
      { id: "doctorName", label: "Prescribed By" },
      { id: "medicine_list", label: "Medicine List" },
      { id: "status_value", label: "Status" },
    ];
    const isModalOpen = this.state.isModalOpen;

    // const { isNewModal } = this.state;
    return (
      <>
        {" "}
        {isModalOpen && (
          <MedicineModal
            isModalOpen={isModalOpen}
            pdfData={this.state.pdfData}
            data={this.state.medicineList}
            tittle="Today's Prescription"
            onClose={this.handleCloseModal}
          />
        )}
        <div className="space-y-5 animate-fadeIn">
          {/* Unified Modern Dashboard Header */}
          <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-3 bg-white p-3 sm:p-3.5 rounded-xl border border-gray-100 shadow-2xs">
            <div>
              <div className="flex items-center gap-2 mb-1">
                <span className="text-[10px] font-bold uppercase tracking-wider text-teal-700 bg-teal-50 px-2 py-0.5 rounded-md border border-teal-100/80">
                  Pharmacy Portal
                </span>
              </div>
              <h1 className="text-base sm:text-lg font-bold text-gray-900 tracking-tight">
                Good {moment().hour() < 12 ? 'Morning' : moment().hour() < 17 ? 'Afternoon' : 'Evening'},{" "}
                <span className="text-teal-600">{this.state.userName || "Pharmacy"}</span>
              </h1>
              <p className="text-gray-500 text-xs font-medium mt-0.5 max-w-xl">
                Real-time overview of your prescriptions, medicine inventory, and patient dispensing.
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-2.5">
              <div className="bg-slate-50 px-2.5 py-1.5 rounded-lg border border-gray-200/80 flex items-center gap-2 shadow-2xs">
                <HiOutlineCalendar className="text-teal-600" size={15} />
                <span className="text-xs font-bold text-gray-800 tracking-wide">
                  {moment().format("DD MMMM, YYYY")}
                </span>
              </div>

              <button
                type="button"
                onClick={this.toggleNewModal}
                className="flex items-center gap-1.5 px-3 py-1.5 bg-teal-600 hover:bg-teal-700 text-white text-xs font-bold rounded-lg transition-all shadow-sm shadow-teal-600/20 active:scale-95 cursor-pointer"
              >
                <HiOutlinePlus size={15} />
                Add Prescription
              </button>
            </div>
          </div>

          {/* Walk-in Prescription Modal */}
          {this.state.isNewModal && (
            <div className="fixed inset-0 z-[9999] flex items-center justify-center p-3 sm:p-4 md:p-6 overflow-y-auto">
              {/* Backdrop */}
              <div
                className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity"
                onClick={this.toggleNewModal}
              />

              {/* Modal Container */}
              <div className="relative w-full max-w-[720px] bg-white rounded-2xl shadow-2xl border border-slate-200/80 overflow-hidden z-10 my-auto flex flex-col max-h-[90vh] animate-in fade-in zoom-in-95 duration-200">
                <div className="p-0 flex flex-col overflow-hidden relative">
                  {/* Modal Header */}
                  <div className="px-5 py-3.5 bg-gradient-to-r from-slate-50 via-white to-teal-50/40 border-b border-slate-100 sticky top-0 z-40 flex items-center justify-between">
                    <div className="flex items-center gap-2.5">
                      <div className="w-9 h-9 rounded-xl bg-teal-600 text-white flex items-center justify-center font-bold text-lg shadow-sm shadow-teal-600/30">
                        🩺
                      </div>
                      <div>
                        <h2 className="text-lg sm:text-xl font-extrabold text-slate-900 tracking-tight leading-snug">
                          Add <span className="text-teal-600">Prescription</span>
                        </h2>
                        <p className="text-slate-500 text-xs font-medium mt-0.5">
                          Create a new manual prescription entry for a walk-in patient
                        </p>
                      </div>
                    </div>

                    <button
                      type="button"
                      className="w-8 h-8 rounded-full bg-slate-100 hover:bg-red-50 text-slate-400 hover:text-red-500 flex items-center justify-center transition-all cursor-pointer border border-slate-200/70 shadow-2xs"
                      onClick={this.toggleNewModal}
                      title="Close"
                    >
                      <HiOutlineX size={16} />
                    </button>
                  </div>

                  {/* Scrollable Body Content */}
                  <div className="flex-1 overflow-y-auto px-5 py-4 space-y-4">
                    {/* Patient Information Section Card */}
                    <div className="bg-slate-50/60 border border-slate-200/70 rounded-xl p-3.5 space-y-3">
                      <div className="flex items-center justify-between border-b border-slate-200/60 pb-2">
                        <span className="text-xs font-bold text-slate-700 uppercase tracking-wider flex items-center gap-1.5">
                          <HiOutlineUser className="text-teal-600" size={15} />
                          Patient Information
                        </span>
                        <span className="text-[10px] font-bold uppercase tracking-wider bg-teal-50 text-teal-700 px-2 py-0.5 rounded-md border border-teal-100">
                          Walk-In Entry
                        </span>
                      </div>

                      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        {/* Phone Number with Auto-complete Search Dropdown */}
                        <div className="space-y-1 relative">
                          <label className="block text-[11px] font-bold text-slate-600 uppercase tracking-wider">
                            Contact Phone <span className="text-red-500">*</span>
                          </label>
                          <div className="relative group">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400 group-focus-within:text-teal-600">
                              <HiOutlinePhone size={16} />
                            </div>
                            <input
                              type="tel"
                              className={`block w-full pl-9 pr-3 h-9 border ${this.state.errors?.patientPricriptionPhoneNumber ? 'border-red-500 bg-red-50/10' : 'border-slate-300 bg-white group-hover:border-slate-400'} rounded-lg focus:ring-2 focus:ring-teal-500/10 focus:border-teal-600 transition-all outline-none text-slate-900 text-xs sm:text-sm font-medium`}
                              placeholder="Enter 10-digit phone number"
                              maxLength="10"
                              value={this.state.patientPricriptionPhoneNumber}
                              onFocus={() => {
                                if (this.state.phoneSearchResults.length > 0) {
                                  this.setState({ showPhoneDropdown: true });
                                }
                              }}
                              onChange={(e) => this.handlePhoneNumberChange(e.target.value)}
                            />
                            {this.state.searchingPhone && (
                              <div className="absolute right-3 top-2.5 text-[10px] font-bold text-teal-600 animate-pulse">Searching...</div>
                            )}
                          </div>

                          {/* Phone Search Auto-complete Dropdown */}
                          {this.state.showPhoneDropdown && this.state.phoneSearchResults.length > 0 && (
                            <div className="absolute z-50 left-0 right-0 top-full mt-1 bg-white rounded-xl border border-teal-200 shadow-xl max-h-56 overflow-y-auto divide-y divide-gray-100">
                              {this.state.phoneSearchResults.map((patient, idx) => (
                                <button
                                  key={idx}
                                  type="button"
                                  onClick={() => this.selectPatientFromPhoneSearch(patient)}
                                  className="w-full text-left px-3 py-2 hover:bg-teal-50 transition-colors flex items-center justify-between cursor-pointer"
                                >
                                  <div>
                                    <p className="text-xs font-bold text-gray-900 flex items-center gap-2">
                                      <span>{patient.name}</span>
                                      {patient.patient_id ? (
                                        <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-teal-100 text-teal-800 font-bold">Registered</span>
                                      ) : (
                                        <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-slate-100 text-slate-700 font-bold">Walk-in</span>
                                      )}
                                    </p>
                                    <p className="text-[11px] text-gray-500 font-mono mt-0.5">
                                      📱 {patient.phonenumber} {patient.gender ? `• ${patient.gender}` : ""} {patient.age ? `• ${patient.age} yrs` : ""}
                                    </p>
                                  </div>
                                  <HiOutlineCheckCircle className="text-teal-600 shrink-0" size={16} />
                                </button>
                              ))}
                            </div>
                          )}

                          {this.state.errors?.patientPricriptionPhoneNumber && (
                            <p className="text-[10px] text-red-500 font-bold ml-1">{this.state.errors.patientPricriptionPhoneNumber}</p>
                          )}
                        </div>

                        {/* Patient Name */}
                        <div className="space-y-1">
                          <label className="block text-[11px] font-bold text-slate-600 uppercase tracking-wider">
                            Patient Name <span className="text-red-500">*</span>
                          </label>
                          <div className="relative group">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400 group-focus-within:text-teal-600">
                              <HiOutlineUser size={16} />
                            </div>
                            <input
                              type="text"
                              className={`block w-full pl-9 pr-3 h-9 border ${this.state.errors?.patientPricriptionName ? 'border-red-500 bg-red-50/10' : 'border-slate-300 bg-white group-hover:border-slate-400'} rounded-lg focus:ring-2 focus:ring-teal-500/10 focus:border-teal-600 transition-all outline-none text-slate-900 text-xs sm:text-sm font-medium`}
                              placeholder="Enter Patient Full Name"
                              value={this.state.patientPricriptionName}
                              onChange={(e) => this.handleNameChange(e.target.value)}
                            />
                          </div>
                          {this.state.errors?.patientPricriptionName && (
                            <p className="text-[10px] text-red-500 font-bold ml-1">{this.state.errors.patientPricriptionName}</p>
                          )}
                        </div>

                        {/* Age */}
                        <div className="space-y-1">
                          <label className="block text-[11px] font-bold text-slate-600 uppercase tracking-wider">
                            Age <span className="text-red-500">*</span>
                          </label>
                          <div className="relative group">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400 group-focus-within:text-teal-600">
                              <HiOutlineCalendar size={16} />
                            </div>
                            <input
                              type="number"
                              max="99"
                              min="0"
                              className={`block w-full pl-9 pr-3 h-9 border ${this.state.errors?.patientPricriptionAge ? 'border-red-500 bg-red-50/10' : 'border-slate-300 bg-white group-hover:border-slate-400'} rounded-lg focus:ring-2 focus:ring-teal-500/10 focus:border-teal-600 transition-all outline-none text-slate-900 text-xs sm:text-sm font-medium`}
                              placeholder="e.g. 28"
                              value={this.state.patientPricriptionAge}
                              onKeyDown={(e) => (["e", "+", "-"].includes(e.key)) && e.preventDefault()}
                              onInput={(e) => { e.target.value = e.target.value.slice(0, 2); }}
                              onChange={(e) => this.handleAgeChange(e.target.value)}
                            />
                          </div>
                          {this.state.errors?.patientPricriptionAge && (
                            <p className="text-[10px] text-red-500 font-bold ml-1">{this.state.errors.patientPricriptionAge}</p>
                          )}
                        </div>

                        {/* Gender */}
                        <div className="space-y-1">
                          <label className="block text-[11px] font-bold text-slate-600 uppercase tracking-wider">
                            Gender <span className="text-red-500">*</span>
                          </label>
                          <div className="relative group">
                            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-400 group-focus-within:text-teal-600">
                              <HiOutlineUserGroup size={16} />
                            </div>
                            <select
                              className={`block w-full pl-9 pr-7 h-9 border appearance-none ${this.state.errors?.patientPricriptionGender ? 'border-red-500 bg-red-50/10' : 'border-slate-300 bg-white group-hover:border-slate-400'} rounded-lg focus:ring-2 focus:ring-teal-500/10 focus:border-teal-600 transition-all outline-none text-slate-900 text-xs sm:text-sm font-medium cursor-pointer`}
                              value={this.state.patientPricriptionGender}
                              onChange={(e) => this.handleGenderChange(e.target.value)}
                            >
                              <option value="" disabled>Select Gender</option>
                              <option value="M">Male</option>
                              <option value="F">Female</option>
                              <option value="other">Other</option>
                            </select>
                            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-slate-400 group-focus-within:text-teal-600">
                              <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                              </svg>
                            </div>
                          </div>
                          {this.state.errors?.patientPricriptionGender && (
                            <p className="text-[10px] text-red-500 font-bold ml-1">{this.state.errors.patientPricriptionGender}</p>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Medicine Selection Section */}
                    <div className="space-y-1.5">
                      <div className="flex items-center justify-between">
                        <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider flex items-center gap-1.5">
                          <HiOutlineCube className="text-teal-600" size={15} />
                          Select Medicines (Inventory)
                        </label>
                        {this.state.duplicatesearchmedicinedata.length > 0 && (
                          <span className="text-[10px] font-bold text-teal-700 bg-teal-50 border border-teal-200 px-2 py-0.5 rounded-full">
                            {this.state.duplicatesearchmedicinedata.length} {this.state.duplicatesearchmedicinedata.length === 1 ? 'medicine' : 'medicines'} selected
                          </span>
                        )}
                      </div>
                      <Select
                        className="premium-select text-xs sm:text-sm"
                        placeholder="Type to search medicines from pharmacy inventory..."
                        noOptionsMessage={() => "No matching medicines found in inventory"}
                        value={this.state.searchmedicinedata.filter(
                          (obj) => this.state.duplicatesearchmedicinedata.some(s => s.value === obj.value)
                        )}
                        options={this.state.searchmedicinedata.map((option) => ({
                          ...option,
                          isDisabled: this.state.duplicatesearchmedicinedata.some(
                            (selected) => selected.value === option.value
                          ),
                        }))}
                        onChange={this.selectMedicine}
                        isMulti
                        isClearable
                        styles={{
                          control: (base, state) => ({
                            ...base,
                            fontSize: "13px",
                            fontWeight: "500",
                            minHeight: "38px",
                            borderRadius: "0.5rem",
                            padding: "1px 6px",
                            border: "1px solid #cbd5e1",
                            backgroundColor: "#f8fafc",
                            boxShadow: state.isFocused ? "0 0 0 3px rgba(13, 148, 136, 0.12)" : "none",
                            borderColor: state.isFocused ? "#0d9488" : "#cbd5e1",
                            "&:hover": { borderColor: "#0d9488" }
                          }),
                          multiValue: (base) => ({
                            ...base,
                            backgroundColor: "#ccfbf1",
                            borderRadius: "6px",
                            padding: "1px 6px"
                          }),
                          multiValueLabel: (base) => ({
                            ...base,
                            color: "#0f766e",
                            fontWeight: "600",
                            fontSize: "12px"
                          }),
                          multiValueRemove: (base) => ({
                            ...base,
                            color: "#0f766e",
                            "&:hover": { backgroundColor: "#0f766e", color: "white" }
                          })
                        }}
                      />
                    </div>

                    {/* Added Medicines List Cards / Empty State */}
                    {this.state.duplicatesearchmedicinedata.length > 0 ? (
                      <div className="space-y-2.5 pt-1">
                        <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                          Prescribed Medicine Dosages ({this.state.duplicatesearchmedicinedata.length})
                        </label>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                          {this.state.duplicatesearchmedicinedata.map((val, index) => (
                            <div key={index} className="bg-white rounded-xl border border-slate-200 p-3 shadow-2xs hover:border-teal-300 transition-all relative group/card">
                              {/* Remove Button */}
                              <button
                                type="button"
                                onClick={() => this.deleteTabletFromArray(index)}
                                className="absolute top-2.5 right-2.5 w-6 h-6 rounded-md bg-slate-100 text-slate-400 hover:bg-red-50 hover:text-red-500 flex items-center justify-center transition-all z-10 cursor-pointer"
                                title="Remove medicine"
                              >
                                <HiOutlineX size={14} />
                              </button>

                              <div className="flex items-start gap-2.5 mb-2">
                                <div className="w-7 h-7 rounded-md bg-teal-50 text-teal-600 flex items-center justify-center font-bold text-sm shrink-0">
                                  💊
                                </div>
                                <div className="min-w-0 pr-5">
                                  <h4 className="text-xs font-bold text-slate-900 tracking-tight truncate leading-snug">
                                    {val.label}
                                  </h4>
                                  <p className="text-[11px] text-teal-700 font-semibold mt-0.5">
                                    {"₹"} {val.originalPrice || 0} / unit
                                  </p>
                                </div>
                              </div>

                              {/* Daily Schedule (Morn, Noon, Eve, Night) */}
                              <div className="grid grid-cols-4 gap-1 mb-2 bg-slate-50 p-1.5 rounded-lg border border-slate-100">
                                {["Morn", "Noon", "Eve", "Night"].map((time, tabletindex) => (
                                  <div key={tabletindex} className="flex flex-col items-center">
                                    <p className="text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-0.5">{time}</p>
                                    <div className="flex items-center gap-1 bg-white px-1.5 py-0.5 rounded border border-slate-200">
                                      <button
                                        type="button"
                                        onClick={() => this.medicinedecrenet(index, tabletindex)}
                                        className="text-slate-400 hover:text-teal-600 text-xs font-bold px-0.5 cursor-pointer"
                                      >
                                        -
                                      </button>
                                      <span className="text-xs font-bold text-teal-700 min-w-2.5 text-center">
                                        {(val.counts?.[tabletindex] ?? 0)}
                                      </span>
                                      <button
                                        type="button"
                                        onClick={() => this.medicineincrement(index, tabletindex)}
                                        className="text-slate-400 hover:text-teal-600 text-xs font-bold px-0.5 cursor-pointer"
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                ))}
                              </div>

                              {/* Days, Food Timing & Subtotal */}
                              <div className="flex items-center justify-between border-t border-slate-100 pt-2">
                                <div className="flex items-center gap-1.5">
                                  {/* Days */}
                                  <div className="flex items-center gap-1 bg-slate-800 text-white px-2 py-0.5 rounded text-xs">
                                    <span className="text-slate-400 text-[10px] font-bold uppercase mr-0.5">Days</span>
                                    <button type="button" onClick={() => this.decrementdays(index)} className="hover:text-teal-400 font-bold px-0.5 cursor-pointer">-</button>
                                    <span className="font-bold text-teal-400">{val.days}</span>
                                    <button type="button" onClick={() => this.incrementdays(index)} className="hover:text-teal-400 font-bold px-0.5 cursor-pointer">+</button>
                                  </div>

                                  {/* Food timing */}
                                  <div className="flex gap-0.5">
                                    <button
                                      type="button"
                                      onClick={() => this.handleTickClick(index, 0)}
                                      className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider transition-all border cursor-pointer ${val.foodtype === 0 ? 'bg-teal-600 text-white border-teal-600' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'}`}
                                    >
                                      Before
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => this.handleTickClick(index, 1)}
                                      className={`px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider transition-all border cursor-pointer ${val.foodtype === 1 ? 'bg-teal-600 text-white border-teal-600' : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50'}`}
                                    >
                                      After
                                    </button>
                                  </div>
                                </div>

                                {/* Subtotal */}
                                <div className="text-right">
                                  <p className="text-[10px] font-semibold text-slate-400 uppercase">Qty: {val.totalmedicine}</p>
                                  <p className="text-xs font-bold text-slate-900">{"₹"} {val.price || 0}</p>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <div className="border border-dashed border-slate-200 rounded-xl p-5 text-center bg-slate-50/30 flex flex-col items-center justify-center gap-1.5">
                        <div className="w-9 h-9 rounded-full bg-teal-50 text-teal-600 flex items-center justify-center text-lg">
                          💊
                        </div>
                        <p className="text-xs font-bold text-slate-700">No medicines selected yet</p>
                        <p className="text-[11px] text-slate-400 max-w-sm">
                          Use the search field above to add medicines from inventory and specify dosages.
                        </p>
                      </div>
                    )}
                  </div>

                  {/* Modal Footer Section */}
                  <div className="bg-slate-900 px-5 py-3.5 flex flex-col sm:flex-row items-center justify-between gap-3 z-40 border-t border-slate-800">
                    <div className="flex items-center gap-3">
                      <div className="w-9 h-9 rounded-xl bg-teal-500/20 text-teal-400 flex items-center justify-center shadow-inner">
                        <HiOutlineCash size={19} />
                      </div>
                      <div>
                        <p className="text-teal-400 text-[10px] font-bold uppercase tracking-widest leading-none mb-1">Total Amount Due</p>
                        <h2 className="text-xl font-black text-white tracking-tight">
                          {"₹"} {this.state.duplicatesearchmedicinedata.reduce((acc, curr) => acc + (curr.price || 0), 0)}
                        </h2>
                      </div>
                    </div>

                    <div className="flex items-center gap-2.5 w-full sm:w-auto justify-end">
                      <button
                        type="button"
                        onClick={this.toggleNewModal}
                        className="px-4 py-2 text-xs font-bold text-slate-400 hover:text-white uppercase tracking-wider transition-colors cursor-pointer"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        onClick={() => this.addPresscription()}
                        className="px-4 py-2 bg-teal-600 hover:bg-teal-500 text-white font-bold text-xs uppercase tracking-wider rounded-lg transition-all shadow-md shadow-teal-600/30 active:scale-95 flex items-center gap-1.5 cursor-pointer"
                      >
                        <HiOutlineCheckCircle size={16} />
                        <span>Confirm Prescription</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* ================================== PHARMACY LIFECYCLE & KPI METRIC CARDS ================================== */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2.5 sm:gap-3">
            {/* Card 1: Today's Prescriptions */}
            <NavLink
              to="/Home/prescription"
              className="bg-white p-2.5 sm:p-3 rounded-xl border border-gray-100 shadow-2xs hover:shadow-sm hover:border-teal-200 transition-all group flex flex-col justify-between"
            >
              <div className="flex items-center justify-between gap-2">
                <div>
                  <p className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Today's Prescriptions</p>
                  <h3 className="text-base sm:text-lg font-bold text-slate-900 mt-0.5 tracking-tight">
                    {this.state.tabledatavalue?.length || this.state.prescription || 0}
                  </h3>
                </div>
                <div className="w-7 h-7 rounded-lg bg-teal-50 text-teal-600 flex items-center justify-center group-hover:scale-105 transition-transform shadow-2xs shrink-0">
                  <HiOutlineDocumentText size={15} />
                </div>
              </div>
              <div className="flex items-center justify-between pt-1.5 mt-1.5 border-t border-gray-100 text-[11px] font-semibold text-teal-600 group-hover:text-teal-700">
                <span>Active Queue</span>
                <HiOutlineChevronRight size={13} className="transform group-hover:translate-x-0.5 transition-transform" />
              </div>
            </NavLink>

            {/* Card 2: Pending Quotes */}
            <NavLink
              to="/Home/pending_quotes"
              className="bg-white p-2.5 sm:p-3 rounded-xl border border-gray-100 shadow-2xs hover:shadow-sm hover:border-amber-200 transition-all group flex flex-col justify-between"
            >
              <div className="flex items-center justify-between gap-2">
                <div>
                  <p className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Pending Quotes</p>
                  <h3 className="text-base sm:text-lg font-bold text-slate-900 mt-0.5 tracking-tight">
                    {this.state.quotes_pending || 0}
                  </h3>
                </div>
                <div className="w-7 h-7 rounded-lg bg-amber-50 text-amber-600 flex items-center justify-center group-hover:scale-105 transition-transform shadow-2xs shrink-0">
                  <HiOutlineClock size={15} />
                </div>
              </div>
              <div className="flex items-center justify-between pt-1.5 mt-1.5 border-t border-gray-100 text-[11px] font-semibold text-amber-600 group-hover:text-amber-700">
                <span>Needs Quotation</span>
                <HiOutlineChevronRight size={13} className="transform group-hover:translate-x-0.5 transition-transform" />
              </div>
            </NavLink>

            {/* Card 3: Pending Member Approvals */}
            <NavLink
              to="/Home/pending_approvals"
              className="bg-white p-2.5 sm:p-3 rounded-xl border border-gray-100 shadow-2xs hover:shadow-sm hover:border-blue-200 transition-all group flex flex-col justify-between"
            >
              <div className="flex items-center justify-between gap-2">
                <div>
                  <p className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Member Approvals</p>
                  <h3 className="text-base sm:text-lg font-bold text-slate-900 mt-0.5 tracking-tight">
                    {this.state.pending_approval || 0}
                  </h3>
                </div>
                <div className="w-7 h-7 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center group-hover:scale-105 transition-transform shadow-2xs shrink-0">
                  <HiOutlineCheckCircle size={15} />
                </div>
              </div>
              <div className="flex items-center justify-between pt-1.5 mt-1.5 border-t border-gray-100 text-[11px] font-semibold text-blue-600 group-hover:text-blue-700">
                <span>Waiting for Patient</span>
                <HiOutlineChevronRight size={13} className="transform group-hover:translate-x-0.5 transition-transform" />
              </div>
            </NavLink>

            {/* Card 4: Pending Orders */}
            <NavLink
              to="/Home/pending_orders"
              className="bg-white p-2.5 sm:p-3 rounded-xl border border-gray-100 shadow-2xs hover:shadow-sm hover:border-indigo-200 transition-all group flex flex-col justify-between"
            >
              <div className="flex items-center justify-between gap-2">
                <div>
                  <p className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Pending Orders</p>
                  <h3 className="text-base sm:text-lg font-bold text-slate-900 mt-0.5 tracking-tight">
                    {this.state.pending_order || 0}
                  </h3>
                </div>
                <div className="w-7 h-7 rounded-lg bg-indigo-50 text-indigo-600 flex items-center justify-center group-hover:scale-105 transition-transform shadow-2xs shrink-0">
                  <HiOutlineShoppingCart size={15} />
                </div>
              </div>
              <div className="flex items-center justify-between pt-1.5 mt-1.5 border-t border-gray-100 text-[11px] font-semibold text-indigo-600 group-hover:text-indigo-700">
                <span>Processing & Packing</span>
                <HiOutlineChevronRight size={13} className="transform group-hover:translate-x-0.5 transition-transform" />
              </div>
            </NavLink>

            {/* Card 5: Completed Prescriptions */}
            <NavLink
              to="/Home/totalorders"
              className="bg-white p-2.5 sm:p-3 rounded-xl border border-gray-100 shadow-2xs hover:shadow-sm hover:border-emerald-200 transition-all group flex flex-col justify-between"
            >
              <div className="flex items-center justify-between gap-2">
                <div>
                  <p className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Completed Orders</p>
                  <h3 className="text-base sm:text-lg font-bold text-slate-900 mt-0.5 tracking-tight">
                    {this.state.deliverd || 0}
                  </h3>
                </div>
                <div className="w-7 h-7 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center group-hover:scale-105 transition-transform shadow-2xs shrink-0">
                  <HiOutlineArchive size={15} />
                </div>
              </div>
              <div className="flex items-center justify-between pt-1.5 mt-1.5 border-t border-gray-100 text-[11px] font-semibold text-emerald-600 group-hover:text-emerald-700">
                <span>Delivered History</span>
                <HiOutlineChevronRight size={13} className="transform group-hover:translate-x-0.5 transition-transform" />
              </div>
            </NavLink>

            {/* Card 6: Canceled Quotes */}
            <NavLink
              to="/Home/cancelorders"
              className="bg-white p-2.5 sm:p-3 rounded-xl border border-gray-100 shadow-2xs hover:shadow-sm hover:border-rose-200 transition-all group flex flex-col justify-between"
            >
              <div className="flex items-center justify-between gap-2">
                <div>
                  <p className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Canceled Quotes</p>
                  <h3 className="text-base sm:text-lg font-bold text-slate-900 mt-0.5 tracking-tight">
                    {this.state.cancel_count || 0}
                  </h3>
                </div>
                <div className="w-7 h-7 rounded-lg bg-rose-50 text-rose-600 flex items-center justify-center group-hover:scale-105 transition-transform shadow-2xs shrink-0">
                  <HiOutlineXCircle size={15} />
                </div>
              </div>
              <div className="flex items-center justify-between pt-1.5 mt-1.5 border-t border-gray-100 text-[11px] font-semibold text-rose-600 group-hover:text-rose-700">
                <span>Canceled Records</span>
                <HiOutlineChevronRight size={13} className="transform group-hover:translate-x-0.5 transition-transform" />
              </div>
            </NavLink>

            {/* Card 7: Medicine Inventory */}
            <NavLink
              to="/Home/medicine"
              className="bg-white p-2.5 sm:p-3 rounded-xl border border-gray-100 shadow-2xs hover:shadow-sm hover:border-cyan-200 transition-all group flex flex-col justify-between"
            >
              <div className="flex items-center justify-between gap-2">
                <div>
                  <p className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Medicine Master</p>
                  <h3 className="text-base sm:text-lg font-bold text-slate-900 mt-0.5 tracking-tight">
                    Inventory
                  </h3>
                </div>
                <div className="w-7 h-7 rounded-lg bg-cyan-50 text-cyan-600 flex items-center justify-center group-hover:scale-105 transition-transform shadow-2xs shrink-0">
                  <HiOutlineCube size={15} />
                </div>
              </div>
              <div className="flex items-center justify-between pt-1.5 mt-1.5 border-t border-gray-100 text-[11px] font-semibold text-cyan-600 group-hover:text-cyan-700">
                <span>Manage Stock & Rates</span>
                <HiOutlineChevronRight size={13} className="transform group-hover:translate-x-0.5 transition-transform" />
              </div>
            </NavLink>

            {/* Card 8: Total Revenue */}
            <NavLink
              to="/Home/revenue"
              className="bg-white p-2.5 sm:p-3 rounded-xl border border-gray-100 shadow-2xs hover:shadow-sm hover:border-teal-200 transition-all group flex flex-col justify-between"
            >
              <div className="flex items-center justify-between gap-2">
                <div>
                  <p className="text-[10px] font-bold uppercase tracking-wider text-slate-500">Total Revenue ({"₹"})</p>
                  <h3 className="text-base sm:text-lg font-bold text-slate-900 mt-0.5 tracking-tight">
                    {"₹"} {this.state.getTotalRevenue || 0}
                  </h3>
                </div>
                <div className="w-7 h-7 rounded-lg bg-emerald-50 text-emerald-600 flex items-center justify-center shadow-2xs shrink-0">
                  <HiOutlineTrendingUp size={15} />
                </div>
              </div>
              <div className="flex items-center justify-between pt-1.5 mt-1.5 border-t border-gray-100 text-[11px] font-semibold text-emerald-600 group-hover:text-emerald-700">
                <span>View Settlement</span>
                <HiOutlineChevronRight size={13} className="transform group-hover:translate-x-0.5 transition-transform" />
              </div>
            </NavLink>
          </div>

          {/* ================================== TODAY'S PRESCRIPTIONS TABLE ================================== */}
          <div className="bg-white rounded-xl border border-gray-100 shadow-2xs overflow-hidden flex flex-col mb-5">
            <div className="p-2.5 sm:p-3 border-b border-gray-100 flex flex-col sm:flex-row sm:items-center justify-between gap-2 bg-slate-50/50">
              <div className="flex items-center gap-2.5">
                <div className="w-7.5 h-7.5 rounded-lg bg-teal-100/70 text-teal-700 flex items-center justify-center shadow-2xs shrink-0">
                  <HiOutlineClipboardList size={16} />
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <h2 className="text-sm sm:text-base font-bold text-gray-900 tracking-tight">
                      Today's <span className="text-teal-600">Prescriptions</span>
                    </h2>
                    <span className="px-2 py-0.5 rounded-full bg-teal-50 text-teal-700 text-[10px] font-bold border border-teal-100">
                      {this.state.tabledatavalue.length} {this.state.tabledatavalue.length === 1 ? 'patient' : 'patients'}
                    </span>
                  </div>
                  <p className="text-[11px] text-gray-500 font-medium mt-0.5">
                    Track and dispense medicines for incoming patient prescriptions
                  </p>
                </div>
              </div>

              <NavLink
                to="/Home/prescription"
                className="flex items-center gap-1 text-[11px] font-bold uppercase tracking-wider text-teal-600 hover:text-teal-700 transition-colors"
              >
                <span>View Full Queue</span>
                <HiOutlineChevronRight size={14} />
              </NavLink>
            </div>

            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse">
                <thead>
                  <tr className="bg-slate-50/90 border-b border-gray-200 text-xs font-bold text-slate-700 uppercase tracking-wider select-none">
                    <th className="py-2.5 px-3 text-center w-12">S.No</th>
                    <th className="py-2.5 px-3 text-center w-36">Prescription ID</th>
                    <th className="py-2.5 px-4 text-left min-w-[180px]">Patient Name</th>
                    <th className="py-2.5 px-3 text-center w-24">Gender</th>
                    <th className="py-2.5 px-3 text-center w-36">Phone No</th>
                    <th className="py-2.5 px-4 text-left min-w-[200px]">Prescribed By</th>
                    <th className="py-2.5 px-3 text-center w-32">Medicines</th>
                    <th className="py-2.5 px-3 text-center w-32">Status</th>
                    <th className="py-2.5 px-3 text-center w-36">Action</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 text-xs sm:text-sm">
                  {this.state.props_loading ? (
                    <tr>
                      <td colSpan={9} className="py-12 text-center text-gray-400 font-medium">
                        <div className="flex flex-col items-center justify-center gap-2">
                          <div className="w-6 h-6 border-2 border-teal-600 border-t-transparent rounded-full animate-spin" />
                          <p className="text-xs font-bold text-slate-500 uppercase tracking-wider">Loading prescriptions...</p>
                        </div>
                      </td>
                    </tr>
                  ) : this.state.tabledatavalue.length === 0 ? (
                    <tr>
                      <td colSpan={9} className="py-12 text-center text-gray-400 font-medium">
                        <div className="flex flex-col items-center justify-center gap-1.5">
                          <div className="w-10 h-10 rounded-xl bg-gray-50 flex items-center justify-center text-gray-300 text-xl">
                            📋
                          </div>
                          <p className="text-sm sm:text-base font-bold text-slate-700">No prescriptions found today</p>
                          <p className="text-xs text-slate-400">
                            Click '+ Add Prescription' to register a new walk-in patient
                          </p>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    this.state.tabledatavalue.map((data, index) => {
                      const isQuotePending = !data.status || data.status === "Quote Pending";
                      const isCanceled = data.status === "Canceled";
                      const isDelivered = data.status === "Delivered" || data.status === "Completed";
                      return (
                        <tr
                          key={data.id || index}
                          className="hover:bg-teal-50/20 transition-colors group"
                        >
                          {/* S.No */}
                          <td className="py-2.5 px-3 text-center text-xs font-bold text-slate-500">
                            {index + 1}
                          </td>

                          {/* Prescription ID */}
                          <td className="py-2.5 px-3 text-center">
                            <span className="px-2.5 py-1 rounded-lg bg-teal-50 text-teal-800 font-mono text-xs font-bold border border-teal-100">
                              #{data.orderId}
                            </span>
                          </td>

                          {/* Patient Name */}
                          <td className="py-2.5 px-4 text-left font-bold text-slate-900 text-xs sm:text-sm">
                            {data.customer || "Walk-in Patient"}
                          </td>

                          {/* Gender */}
                          <td className="py-2.5 px-3 text-center">
                            <span className="px-2 py-0.5 rounded-md bg-slate-100 text-slate-800 text-xs font-bold uppercase">
                              {data.gender || "-"}
                            </span>
                          </td>

                          {/* Phone No */}
                          <td className="py-2.5 px-3 text-center text-xs font-semibold text-slate-700 font-mono">
                            {data.customer_phno || "-"}
                          </td>

                          {/* Prescribed By */}
                          <td className="py-2.5 px-4 text-left">
                            <div className="flex items-center gap-2">
                              <div className="w-6.5 h-6.5 rounded-full bg-teal-100/70 text-teal-800 flex items-center justify-center text-xs font-black shrink-0">
                                {(data.doctorName || "D")[0]}
                              </div>
                              <span className="font-bold text-slate-900 text-xs">
                                {data.doctorName || "Direct Pharmacy Entry"}
                              </span>
                            </div>
                          </td>

                          {/* Medicines View */}
                          <td className="py-2.5 px-3 text-center">
                            <button
                              type="button"
                              onClick={() => {
                                const rawItem = (this.state.totalValue || []).find(v => v.prescription_id === data.id) || {};
                                this.viewmedicineList(rawItem);
                              }}
                              className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg bg-teal-50 hover:bg-teal-600 text-teal-700 hover:text-white text-xs font-bold transition-all cursor-pointer shadow-2xs active:scale-95"
                            >
                              <HiOutlineEye size={15} />
                              <span>View List</span>
                            </button>
                          </td>

                          {/* Status */}
                          <td className="py-2.5 px-3 text-center text-xs">
                            <span
                              className={`px-2.5 py-1 rounded-full text-xs font-bold inline-flex items-center justify-center gap-1.5 shadow-2xs ${
                                isCanceled
                                  ? "bg-red-50 text-red-700 border border-red-200"
                                  : isQuotePending
                                  ? "bg-amber-50 text-amber-800 border border-amber-300"
                                  : data.status === "Pending Approval"
                                  ? "bg-blue-50 text-blue-800 border border-blue-200"
                                  : isDelivered
                                  ? "bg-emerald-50 text-emerald-800 border border-emerald-200"
                                  : "bg-purple-50 text-purple-800 border border-purple-200"
                              }`}
                            >
                              <span
                                className={`w-1.5 h-1.5 rounded-full ${
                                  isCanceled
                                    ? "bg-red-500"
                                    : isQuotePending
                                    ? "bg-amber-500 animate-pulse"
                                    : data.status === "Pending Approval"
                                    ? "bg-blue-500"
                                    : isDelivered
                                    ? "bg-emerald-500"
                                    : "bg-purple-500"
                                }`}
                              />
                              {data.status || "Quote Pending"}
                            </span>
                          </td>

                          {/* Action */}
                          <td className="py-2.5 px-3 text-center">
                            {isCanceled ? (
                              <span className="text-xs text-gray-400 font-medium">-</span>
                            ) : isQuotePending ? (
                              <NavLink
                                to={`/Home/prescription?orderId=${data.orderId}&id=${data.id}`}
                                className="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg bg-teal-600 hover:bg-teal-700 text-white text-xs font-bold transition-all cursor-pointer shadow-sm shadow-teal-600/20 active:scale-95 whitespace-nowrap"
                                title="Send Quote for this Prescription"
                              >
                                <HiOutlinePlusCircle size={15} />
                                <span>Send Quote</span>
                              </NavLink>
                            ) : (
                              <NavLink
                                to={`/Home/prescription?orderId=${data.orderId}&id=${data.id}`}
                                className="inline-flex items-center gap-1.5 px-3 py-1 rounded-lg bg-indigo-50 hover:bg-indigo-600 text-indigo-700 hover:text-white text-xs font-bold transition-all cursor-pointer shadow-2xs active:scale-95 whitespace-nowrap"
                                title="Track Order Status"
                              >
                                <HiOutlineRefresh size={15} />
                                <span>Update Status</span>
                              </NavLink>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
          {/* ================================== DASHBOARD TABLE END ==================================  */}
          {/* <div className="barChartsHead">
            <Grid container className="barCharts">
              <Grid item xs={12} md={12}>
                <Grid container>
                  <Grid item xs={10} md={10}>
                    <div className="barMargin">
                      <p className="barIncome">INCOME</p>
                      <hr className="dashboard_table_card_line2" />
                      <p style={{ fontSize: 31, fontWeight: "600" }}>
                        {"₹"} {getTotalRevenue}
                      </p>
                    </div>
                  </Grid>

                  <Grid item xs={2} md={2}>
                    <div
                      className="enter_input_name"
                      style={{ marginTop: "7%" }}
                    >
                      <FormControl sx={{ m: "8px 0px" }} size="small">
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={Var_year}
                          renderValue={(p) => p}
                          onChange={(e) => getYear(e)}
                        >
                          <MenuItem value={2021}>2021</MenuItem>
                          <MenuItem value={2022}>2022</MenuItem>
                          <MenuItem value={2023}>2023</MenuItem>
                          <MenuItem value={2024}>2024</MenuItem>
                          <MenuItem value={2025}>2025</MenuItem>
                          <MenuItem value={2026}>2026</MenuItem>
                          <MenuItem value={2027}>2027</MenuItem>
                          <MenuItem value={2028}>2028</MenuItem>
                          <MenuItem value={2029}>2029</MenuItem>
                          <MenuItem value={2030}>2030</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </Grid>
                </Grid>
                <MonthlyChart data={revenueIncome} />
              </Grid>
            </Grid>
          </div> */}
          <ShowNotification
            visible={this.state.visible}
            successmsg={this.state.successmsg}
            issuccess={this.state.issuccess}
            handleCloseSuccess={this.handleCloseSuccess}
            t={t}
            i18n={this.props.i18n}
          ></ShowNotification>
        </div>
      </>
    );
  }
}
export default DashboardTable;
